Vue.component('ack-sol-build-platforms', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-sol-build-platforms',
	mixins: [languageMixins],
	created() {},
	mounted() {
		this.setPageIsLoading(false);
	},
	props: {
		// dataIn: {
		//   type: Object,
		//   required: true
		// }
		shopProductInfo: {
			type: Object,
			required: false,
		},
	},
	computed: {
		//...Vuex.mapGetters('sliders', ['slidersLists']),
		//...Vuex.mapGetters('articles', ['articlesArray']),
		...Vuex.mapGetters('shop', ['currentCurrency', 'currentCurrencySymbol', 'currentCountryCode']),
		isMobile() {
			return this.$parent.isMobile;
		},
		productIsNotAvailableInRegion() {
			let notAvailable = false;
			if (
				this.currentCountryCode.toUpperCase() == 'US' ||
				this.currentCountryCode.toUpperCase() == 'CA'
			) {
				notAvailable = true;
			}
			return notAvailable;
		},
		isMobile() {
			return this.$parent.isMobile;
		},
	},
	data() {
		return {
			isUsaOrCa: this.$store.getters['localization/isUS_CA'],
			pageId: 'sol-build-platforms-page',
			solBpProducts: [
				{
					productImage:
						window.ackShopifyFileUrl("mediumBP.gif"),
					iconImage:
						window.ackShopifyFileUrl("medium-ico.png"),
					title: 'Medium Build Platform',
					productId: 'gid://shopify/Product/6630922485863',
					variantId: 'gid://shopify/ProductVariant/39604337836135',
					sellingPlanId: null,
					details: [
						'Printing area: 70 x 70 mm',
						'Finishing: Anodized Metal',
						'Compatibility: SOL 3D Printer',
					],
					price: '$7,205.00',
					disclaimer: '*This price does NOT include Shipping, Handling, Customs or Local VAT',
				},
				{
					productImage:
						window.ackShopifyFileUrl("smallBP.gif"),
					iconImage:
						window.ackShopifyFileUrl("small-ico.png"),
					title: 'Small Build Platform',
					productId: 'gid://shopify/Product/6630921502823',
					variantId: 'gid://shopify/ProductVariant/39604336754791',
					sellingPlanId: null,
					details: [
						'Printing area: 40 x 20 mm',
						'Finishing: Anodized Metal',
						'Compatibility: SOL 3D Printer',
					],
					price: '$7,205.00',
					disclaimer: '*This price does NOT include Shipping, Handling, Customs or Local VAT',
				},
			],
			solBpFeatures: [
				{
					icon: window.ackShopifyFileUrl("medium-ico.png"),
					image:
						window.ackShopifyFileUrl("print_model-Dentiq.png"),
					title: 'Model',
					time: '28 Minutes',
					efficiency: '35% Faster',
				},
				{
					icon: window.ackShopifyFileUrl("small-ico.png"),
					image:
						window.ackShopifyFileUrl("print_crown-Dentiq.png"),
					title: 'Crown & Bridge',
					time: '15 Minutes',
					efficiency: '40% Faster',
				},
				{
					icon: null,
					image:
						window.ackShopifyFileUrl("print_Denture-base-Dentiq_80063dbd-4111-462c-8520-e69387da072e.png"),
					title: 'Dentures',
					time: '53 Minutes',
					efficiency: '26% Faster',
				},
				{
					icon: null,
					image:
						window.ackShopifyFileUrl("print_Castable-Crown-Dentiq.png"),
					title: 'Cast',
					time: '30 Minutes',
					efficiency: '50% Faster',
				},
				{
					icon: null,
					image:
						window.ackShopifyFileUrl("print_guide-Dentiq.png"),
					title: 'Surgical Guide',
					time: '33 Minutes',
					efficiency: '23% Faster',
				},
				{
					icon: null,
					image:
						window.ackShopifyFileUrl("print_gingiva-Dentiq.png"),
					title: 'Gingiva',
					time: '30 Minutes',
					efficiency: '10% Faster',
				},
				{
					icon: null,
					image:
						window.ackShopifyFileUrl("print_IBT-Dentiq.png"),
					title: 'IBT',
					time: '84 Minutes',
					efficiency: '32% Faster',
				},
			],

			slidersInfo: {
				hover_slider_image_section: {
					title: 'Build Platforms Engineered to Meet Your Clinical Needs',
					description:
						'The Small, Medium, and Large build platforms are designed to optimize print times and resin usage for specific applications, ranging from rapid crown production in just 20 minutes to efficient full-arch printing. Choose the ideal platform to achieve unmatched speed and precision in your dental 3D printing.',
					image_items: [
						{
							link: '/pages/store?bundle=shop-3dps-9',
							src: window.ackShopifyFileUrl("BP_Page_L_Build_Platform_Banner.jpg"),
							alt: 'Large Build Platform',
							title: 'Large Build Platform',
						},
						{
							link: '/pages/store?bundle=shop-3dps-9',
							src: window.ackShopifyFileUrl("BP_Page_M_Build_Platform_Banner.jpg"),
							alt: 'Medium Build Platform',
							title: 'Medium Build Platform',
						},
						{
							link: '/pages/store?bundle=shop-3dps-9',
							src: window.ackShopifyFileUrl("BP_Page_S_Build_Platform_Banner.jpg"),
							alt: 'Small Build Platform',
							title: 'Small Build Platform',
						},
					],
				},
			},

			productInfo: {
				default_3dps_bundle: 'shop-3dps-9',
				bundle_title: 'Buy SOL SE Build Platforms',
				title_section: {
					title: 'SOL Build Platforms',
					subtitle: 'Build Platforms<br>Optimize Your Print Speed<br>',
					// title_image_text: 'SOL Build Platforms',
					title_img:
						window.ackShopifyFileUrl("sol_se_logo.png"),
					description: 'Transform your dental workflow with our versatile build platforms.',
					image_mobile:
						window.ackShopifyFileUrl("BP_Page_Top_banner_1.jpg"),
					image_desktop:
						window.ackShopifyFileUrl("BP_Page_Top_banner_1.jpg"),
				},
			},
			scrollingInfo: {
				scrolling_section: {
					title: 'What makes SOL SE Build Platforms the ideal choice?',
					scrolling_items: [
						{
							title: 'Smaller Surface, For Faster Print Times',
							description:
								'A smaller Build Platform displaces less resin, reducing wait times between layers.',
							image:
								window.ackShopifyFileUrl("S_vs_L_2_1.gif"),
						},
						{
							title: 'Anodized Finish For Improved Adhesion',
							description:
								"Ackuretta's breakthrough innovation ensures strong adhesion to the Build Platform, minimizing the risk of print failure.",
							image:
								window.ackShopifyFileUrl("1-1_photo.jpg"),
						},
						{
							title: 'Unmatched Versatility',
							description:
								"Print what you need, when you need it. Whether it's a full arch or a crown, choose from two sizes for maximum flexibility.",
							image:
								window.ackShopifyFileUrl("1-3_photo.jpg"),
						},
						{
							title: 'Innovation, Refined',
							description:
								'There are three key factors that influence printing speed. Learn more about the technology behind this innovation.',
							image:
								window.ackShopifyFileUrl("BP_Page_Photo.jpg"),
						},
					],
				},
			},
			image_section: {
				title: 'Experience the Difference With 1-hour Workflows',
				url_image: null,
				image:
					window.ackShopifyFileUrl("BP_Page_Crown_Workflow.jpg"),
				imgAlt: 'Experience_the_Difference_With_1-hour_Workflows_Img',
			},
		};
	},
	methods: {
		...Vuex.mapActions(['setPageIsLoading']),
		//...Vuex.mapActions('sliders', ['getSlideList']),
		...Vuex.mapActions('shop', ['addToCartFromProperties']),
		onAddToCartClick(solBpProducts) {
			appLog.log(`onAddToCart${solBpProducts.title}Click`, LOG_TYPE.debug);
			this.addToCartFromProperties({
				productId: solBpProducts.productId,
				variantId: solBpProducts.variantId,
				sellingPlanId: solBpProducts.sellingPlanId,
			});
		},
	},
	beforeDestroy() {},
	watch: {
		data1: {
			handler() {},
			deep: false,
		},
	},
});
